module.exports = __webpack_public_path__ + "img/categoryFizichiskiyePraktiki.ae33245c.png";